import React from 'react';
import { UtilityText, StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { EmptyStateCard } from '../empty-state-card/empty-state-card.component';

export const EmptySearchCard = () => {
  const { formatMessage } = useIntl();
  return (
    <EmptyStateCard hideImage backgroundColor="$surfaceBackgroundSecondary">
      <StackLayout horizontalAlignment="center">
        <UtilityText emphasis="emphasized">
          {formatMessage({ id: 'NO_RESULTS_FOUND' })}
        </UtilityText>
        <UtilityText emphasis="subtle">
          {formatMessage({ id: 'NO_RESULTS_FOUND_DESCRIPTION' })}
        </UtilityText>
      </StackLayout>
    </EmptyStateCard>
  );
};
